import { TooltipPosition, TrainerData } from "../IronmonMapUtils";

export const kantoTrainers: TrainerData[] = [
  // S.S. Aqua
  {
    name: "Hiker Noland",
    numPokemon: 2,
    pokemonLevels: [59, 63],
    x: 7357,
    y: 5028,
  },
  {
    name: "Pokéfan Colin",
    numPokemon: 1,
    pokemonLevels: [60],
    x: 7298,
    y: 4842,
  },
  {
    name: "Twins Meg & Peg",
    numPokemon: 2,
    pokemonLevels: [59, 59],
    x: 7418,
    y: 4814,
  },
  {
    name: "Firebreather Lyle",
    numPokemon: 3,
    pokemonLevels: [54, 59, 54],
    x: 7875,
    y: 4799,
    spinner: true,
  },
  {
    name: "Sailor Stanly",
    numPokemon: 3,
    pokemonLevels: [59, 62, 51],
    x: 7599,
    y: 5057,
  },
  {
    name: "Juggler Fritz",
    numPokemon: 3,
    pokemonLevels: [56, 56, 56],
    x: 7085,
    y: 5170,
  },
  {
    name: "Sailor Jeff",
    numPokemon: 2,
    pokemonLevels: [60, 60],
    x: 7516,
    y: 5222,
  },
  {
    name: "Picnicker Debra",
    numPokemon: 1,
    pokemonLevels: [62],
    x: 7723,
    y: 5166,
    walker: true,
  },

  // Route 6
  {
    name: "Picnicker Selina",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 7406,
    y: 3555,
  },
  {
    name: "Twins Day & Dani",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 7552,
    y: 3381,
  },
  {
    name: "Camper Virgil",
    numPokemon: 1,
    pokemonLevels: [65],
    x: 7350,
    y: 3346,
  },

  // Route 8
  {
    name: "Biker Dwayne",
    numPokemon: 4,
    pokemonLevels: [57, 59, 60, 62],
    x: 8452,
    y: 2936,
  },
  {
    name: "Biker Harris",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 8452,
    y: 2950,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Biker Zeke",
    numPokemon: 2,
    pokemonLevels: [65, 65],
    x: 8452,
    y: 2963,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Super Nerd Sam",
    numPokemon: 2,
    pokemonLevels: [66, 66],
    x: 8647,
    y: 2892,
    spinner: true,
  },
  {
    name: "Young Couple Moe & Lulu",
    numPokemon: 2,
    pokemonLevels: [65, 65],
    x: 8768,
    y: 2807,
  },
  {
    name: "Super Nerd Tyrone",
    numPokemon: 3,
    pokemonLevels: [60, 60, 60],
    x: 8905,
    y: 2905,
    spinner: true,
  },
  {
    name: "Gentleman Milton",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 9016,
    y: 3006,
  },

  // Route 10
  {
    name: "Pokéfan Robert",
    numPokemon: 1,
    pokemonLevels: [65],
    x: 9574,
    y: 2377,
  },
  {
    name: "Hiker Jim",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 9405,
    y: 2288,
    walker: true,
  },

  // Route 9
  {
    name: "Picnicker Heidi",
    numPokemon: 2,
    pokemonLevels: [65, 65],
    x: 9286,
    y: 1385,
  },
  {
    name: "Hiker Clarke",
    numPokemon: 2,
    pokemonLevels: [65, 68],
    x: 9253,
    y: 1539,
  },
  {
    name: "Hiker Eoin",
    numPokemon: 3,
    pokemonLevels: [63, 63, 63],
    x: 9101,
    y: 1278,
    spinner: true,
  },
  {
    name: "Camper Dean",
    numPokemon: 2,
    pokemonLevels: [66, 63],
    x: 8891,
    y: 1495,
  },
  {
    name: "Camper Sid",
    numPokemon: 3,
    pokemonLevels: [65, 60, 60],
    x: 8382,
    y: 1338,
  },
  {
    name: "Picnicker Edna",
    numPokemon: 2,
    pokemonLevels: [62, 68],
    x: 8472,
    y: 1582,
  },

  // Nugget Bridge
  {
    name: "Team Rocket Grunt",
    numPokemon: 1,
    pokemonLevels: [59],
    x: 7868,
    y: 569,
  },

  // Route 25
  {
    name: "School Kid Dudley",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 8032,
    y: 180,
  },
  {
    name: "Lass Ellen",
    numPokemon: 2,
    pokemonLevels: [60, 66],
    x: 8208,
    y: 213,
  },
  {
    name: "School Kid Joe",
    numPokemon: 2,
    pokemonLevels: [66, 63],
    x: 8499,
    y: 180,
  },
  {
    name: "Camper Lloyd",
    numPokemon: 1,
    pokemonLevels: [69],
    x: 8545,
    y: 80,
  },
  {
    name: "Lass Laura",
    numPokemon: 3,
    pokemonLevels: [57, 62, 62],
    x: 8625,
    y: 178,
  },
  {
    name: "Lass Shannon",
    numPokemon: 3,
    pokemonLevels: [57, 57, 63],
    x: 8688,
    y: 213,
  },
  {
    name: "Super Nerd Pat",
    numPokemon: 1,
    pokemonLevels: [71],
    x: 8818,
    y: 141,
  },
  {
    name: "Ace Trainer Kevin",
    numPokemon: 3,
    pokemonLevels: [72, 69, 69],
    x: 8948,
    y: 166,
  },

  // Route 12
  {
    name: "Fisherman Kyle",
    numPokemon: 3,
    pokemonLevels: [59, 53, 59],
    x: 9314,
    y: 3259,
  },
  {
    name: "Bird Keeper Justin",
    numPokemon: 2,
    pokemonLevels: [66, 59],
    x: 9365,
    y: 3436,
    spinner: true,
  },
  {
    name: "Fisherman Martin",
    numPokemon: 2,
    pokemonLevels: [54, 63],
    x: 9444,
    y: 3468,
  },
  {
    name: "Young Couple Vic & Tara",
    numPokemon: 2,
    pokemonLevels: [66, 65],
    x: 9411,
    y: 3676,
  },
  {
    name: "Fisherman Stephen",
    numPokemon: 3,
    pokemonLevels: [65, 57, 57],
    x: 9524,
    y: 3672,
  },
  {
    name: "Bird Keeper Gail",
    numPokemon: 2,
    pokemonLevels: [63, 59],
    x: 9376,
    y: 3961,
    spinner: true,
  },
  {
    name: "Fisherman Barney",
    numPokemon: 3,
    pokemonLevels: [60, 56, 56],
    x: 9539,
    y: 4105,
  },
  {
    name: "Fisherman Kyler",
    numPokemon: 3,
    pokemonLevels: [27, 27, 27],
    x: 9427,
    y: 4310,
  },

  // Route 13
  {
    name: "Bird Keeper Bret",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 9507,
    y: 4700,
  },
  {
    name: "Picnicker Piper",
    numPokemon: 1,
    pokemonLevels: [60],
    x: 9474,
    y: 4798,
  },
  {
    name: "Bird Keeper Perry",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 9377,
    y: 4853,
  },
  {
    name: "Young Couple Tim & Sue",
    numPokemon: 2,
    pokemonLevels: [62, 69],
    x: 9193,
    y: 4798,
  },
  {
    name: "Pokéfan Joshua",
    numPokemon: 6,
    pokemonLevels: [48, 48, 48, 48, 48, 48],
    x: 9026,
    y: 4824,
    spinner: true,
  },
  {
    name: "Pokéfan Alex",
    numPokemon: 3,
    pokemonLevels: [44, 44, 98],
    x: 8782,
    y: 4800,
  },
  {
    name: "Camper Clark",
    numPokemon: 1,
    pokemonLevels: [60],
    x: 8147,
    y: 4770,
    spinner: true,
  },
  {
    name: "Picnicker Ginger",
    numPokemon: 1,
    pokemonLevels: [62],
    x: 8340,
    y: 4796,
  },
  {
    name: "Camper Tanner",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 8547,
    y: 4863,
  },
  {
    name: "Hiker Kenny",
    numPokemon: 3,
    pokemonLevels: [41, 44, 50],
    x: 8196,
    y: 4861,
    spinner: true,
  },

  // Route 14
  {
    name: "Bird Keeper Josh",
    numPokemon: 1,
    pokemonLevels: [56],
    x: 8261,
    y: 5203,
  },
  {
    name: "Pokéfan Trevor",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 8371,
    y: 5254,
    spinner: true,
  },
  {
    name: "Pokéfan Carter",
    numPokemon: 3,
    pokemonLevels: [57, 57, 57],
    x: 8339,
    y: 5620,
  },
  {
    name: "Bird Keeper Roy",
    numPokemon: 2,
    pokemonLevels: [57, 66],
    x: 8241,
    y: 5789,
    spinner: true,
  },
  {
    name: "School Kid Connor",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 8115,
    y: 5421,
  },
  {
    name: "Teacher Clarice",
    numPokemon: 2,
    pokemonLevels: [62, 65],
    x: 8194,
    y: 5379,
  },
  {
    name: "School Kid Torin",
    numPokemon: 2,
    pokemonLevels: [62, 59],
    x: 8114,
    y: 5379,
  },
  {
    name: "School Kid Travis",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 8114,
    y: 5335,
  },

  // Route 15
  {
    name: "School Kid Billy",
    numPokemon: 3,
    pokemonLevels: [59, 56, 53],
    x: 7620,
    y: 5630,
  },
  {
    name: "Teacher Colette",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 7216,
    y: 5642,
  },
  {
    name: "Twins Kay & Tia",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 7014,
    y: 5612,
  },
  {
    name: "Pokéfan Eleanor",
    numPokemon: 2,
    pokemonLevels: [65, 62],
    x: 6914,
    y: 5600,
  },
  {
    name: "School Kid Kipp",
    numPokemon: 4,
    pokemonLevels: [54, 60, 54, 60],
    x: 6852,
    y: 5794,
  },
  {
    name: "School Kid Tommy",
    numPokemon: 2,
    pokemonLevels: [62, 65],
    x: 6871,
    y: 5869,
  },
  {
    name: "Teacher Hillary",
    numPokemon: 2,
    pokemonLevels: [62, 47],
    x: 7074,
    y: 5792,
  },
  {
    name: "Pokéfan Boone",
    numPokemon: 2,
    pokemonLevels: [65, 62],
    x: 7448,
    y: 5872,
  },
  {
    name: "School Kid Johnny",
    numPokemon: 3,
    pokemonLevels: [59, 60, 63],
    x: 7685,
    y: 5806,
  },

  // Route 17
  {
    name: "Biker Dale",
    numPokemon: 1,
    pokemonLevels: [71],
    x: 4854,
    y: 3878,
  },
  {
    name: "Biker Reese",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 4827,
    y: 4001,
  },
  {
    name: "Biker Joel",
    numPokemon: 2,
    pokemonLevels: [65, 65],
    x: 4968,
    y: 4151,
  },
  {
    name: "Biker Jacob",
    numPokemon: 2,
    pokemonLevels: [65, 65],
    x: 4903,
    y: 4227,
  },
  {
    name: "Biker Ernest",
    numPokemon: 2,
    pokemonLevels: [68, 66],
    x: 4882,
    y: 5401,
  },
  {
    name: "Biker Aiden",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 4693,
    y: 4242,
    walker: true,
  },
  {
    name: "Biker Dan",
    numPokemon: 3,
    pokemonLevels: [59, 56, 56],
    x: 4697,
    y: 4479,
  },
  {
    name: "Biker Theron",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 4809,
    y: 4477,
  },
  {
    name: "Biker Glenn",
    numPokemon: 3,
    pokemonLevels: [59, 62, 65],
    x: 4729,
    y: 4994,
    spinner: true,
  },
  {
    name: "Biker Teddy",
    numPokemon: 1,
    pokemonLevels: [69],
    x: 4776,
    y: 5360,
  },
  {
    name: "Biker Markey",
    numPokemon: 1,
    pokemonLevels: [71],
    x: 4684,
    y: 5407,
  },

  // Route 18
  {
    name: "Biker Charles",
    numPokemon: 3,
    pokemonLevels: [62, 62, 63],
    x: 4808,
    y: 5669,
  },
  {
    name: "Bird Keeper Bob",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 5323,
    y: 5795,
  },
  {
    name: "Bird Keeper Boris",
    numPokemon: 3,
    pokemonLevels: [59, 56, 62],
    x: 5243,
    y: 5807,
  },

  // Route 11
  {
    name: "Psychic Herman",
    numPokemon: 3,
    pokemonLevels: [59, 59, 59],
    x: 8934,
    y: 3819,
    walker: true,
  },
  {
    name: "Youngster Jason",
    numPokemon: 2,
    pokemonLevels: [63, 63],
    x: 8760,
    y: 3641,
    walker: true,
  },
  {
    name: "Youngster Owen",
    numPokemon: 1,
    pokemonLevels: [66],
    x: 8684,
    y: 3754,
    spinner: true,
  },
  {
    name: "Psychic Fidel",
    numPokemon: 1,
    pokemonLevels: [65],
    x: 8543,
    y: 3723,
    spinner: true,
  },

  // Route 2
  {
    name: "Bug Catcher Ed",
    numPokemon: 3,
    pokemonLevels: [65, 65, 65],
    x: 3123,
    y: 1580,
    spinner: true,
  },
  {
    name: "Bug Catcher Doug",
    numPokemon: 2,
    pokemonLevels: [60, 59],
    x: 3250,
    y: 2847,
  },
  {
    name: "Bug Catcher Rob",
    numPokemon: 2,
    pokemonLevels: [59, 56],
    x: 3142,
    y: 2730,
  },

  // Route 3
  {
    name: "Youngster Regis",
    numPokemon: 2,
    pokemonLevels: [60, 60],
    x: 4224,
    y: 1229,
  },
  {
    name: "Youngster Warren",
    numPokemon: 2,
    pokemonLevels: [57, 63],
    x: 4329,
    y: 1167,
  },
  {
    name: "Youngster Jimmy",
    numPokemon: 3,
    pokemonLevels: [63, 63, 63],
    x: 4395,
    y: 1147,
  },
  {
    name: "Double Team Zac & Jen",
    numPokemon: 2,
    pokemonLevels: [71, 71],
    x: 4251,
    y: 1286,
  },
  {
    name: "Firebreather Otis",
    numPokemon: 3,
    pokemonLevels: [65, 60, 71],
    x: 4538,
    y: 1355,
  },

  // Route 4
  {
    name: "Hiker Bruce",
    numPokemon: 3,
    pokemonLevels: [59, 66, 68],
    x: 4727,
    y: 1376,
    spinner: true,
  },
  {
    name: "Black Belt Manford",
    numPokemon: 1,
    pokemonLevels: [71],
    x: 4868,
    y: 1461,
  },
  {
    name: "Black Belt Ander",
    numPokemon: 3,
    pokemonLevels: [65, 59, 66],
    x: 5110,
    y: 1537,
  },
  {
    name: "Hiker Dwight",
    numPokemon: 2,
    pokemonLevels: [66, 66],
    x: 5200,
    y: 1556,
  },
  {
    name: "Firebreather Burt",
    numPokemon: 2,
    pokemonLevels: [63, 68],
    x: 5221,
    y: 1387,
    spinner: true,
  },

  // Mt. Moon
  {
    name: "Rival",
    numPokemon: 6,
    pokemonLevels: [69, 71, 69, 72, 72, 75],
    x: 4352,
    y: 830,
  },

  // Route 4 (Cerulean Side)
  {
    name: "Picnicker Hope",
    numPokemon: 1,
    pokemonLevels: [66],
    x: 6209,
    y: 989,
  },
  {
    name: "Bird Keeper Hank",
    numPokemon: 2,
    pokemonLevels: [20, 66],
    x: 6559,
    y: 1009,
  },
  {
    name: "Picnicker Sharon",
    numPokemon: 2,
    pokemonLevels: [62, 65],
    x: 6786,
    y: 956,
  },

  // Viridan Forest
  {
    name: "Bug Catcher Abner",
    numPokemon: 3,
    pokemonLevels: [66, 66, 66],
    x: 3692,
    y: 1973,
  },
  {
    name: "Bug Catcher Ellis",
    numPokemon: 3,
    pokemonLevels: [42, 57, 69],
    x: 4102,
    y: 1776,
    walker: true,
  },
  {
    name: "Bug Catcher Stacey",
    numPokemon: 3,
    pokemonLevels: [78, 84, 90],
    x: 4220,
    y: 2135,
  },
  {
    name: "Bug Catcher Dion",
    numPokemon: 1,
    pokemonLevels: [75],
    x: 4220,
    y: 2379,
  },
  {
    name: "Bug Catcher Dane",
    numPokemon: 2,
    pokemonLevels: [66, 72],
    x: 4232,
    y: 2701,
  },

  // Route 1
  {
    name: "School Kid Sherman",
    numPokemon: 2,
    pokemonLevels: [65, 65],
    x: 3285,
    y: 4083,
  },
  {
    name: "School Kid Danny",
    numPokemon: 3,
    pokemonLevels: [65, 65, 65],
    x: 3184,
    y: 4154,
  },
  {
    name: "Ace Trainer French",
    numPokemon: 2,
    pokemonLevels: [71, 71],
    x: 3247,
    y: 4313,
    spinner: true,
  },
  {
    name: "Ace Trainer Quinn",
    numPokemon: 2,
    pokemonLevels: [71, 71],
    x: 3308,
    y: 4434,
  },

  // Route 21
  {
    name: "Swimmer Nikki",
    numPokemon: 2,
    pokemonLevels: [56, 63],
    x: 3255,
    y: 5385,
  },
  {
    name: "Fisherman Arnold",
    numPokemon: 1,
    pokemonLevels: [66],
    x: 3417,
    y: 5480,
  },
  {
    name: "Bird Keeper Kinsley",
    numPokemon: 3,
    pokemonLevels: [54, 54, 56],
    x: 3177,
    y: 5572,
  },
  {
    name: "Fisherman Murphy",
    numPokemon: 4,
    pokemonLevels: [48, 51, 54, 57],
    x: 3147,
    y: 5653,
  },
  {
    name: "Swimmer Chelan",
    numPokemon: 1,
    pokemonLevels: [60],
    x: 3211,
    y: 5765,
  },
  {
    name: "Fisherman Liam",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 3179,
    y: 5998,
  },
  {
    name: "Swimmer Tyson",
    numPokemon: 2,
    pokemonLevels: [63, 63],
    x: 3370,
    y: 6001,
  },
  {
    name: "Fisherman Gideon",
    numPokemon: 2,
    pokemonLevels: [66, 60],
    x: 3202,
    y: 6217,
  },
  {
    name: "Swmimmer Esteban",
    numPokemon: 2,
    pokemonLevels: [57, 57],
    x: 3279,
    y: 6338,
  },
  {
    name: "Swmimmer Duane",
    numPokemon: 2,
    pokemonLevels: [60, 60],
    x: 3450,
    y: 6337,
  },
  {
    name: "Bird Keeper Easton",
    numPokemon: 4,
    pokemonLevels: [53, 53, 53, 54],
    x: 3115,
    y: 6425,
  },
  {
    name: "Swimmer Kendra",
    numPokemon: 1,
    pokemonLevels: [65],
    x: 3403,
    y: 6515,
  },

  // Route 20
  {
    name: "Swimmer Frankie",
    numPokemon: 1,
    pokemonLevels: [66],
    x: 3731,
    y: 6669,
  },
  {
    name: "Bird Keeper Bert",
    numPokemon: 2,
    pokemonLevels: [69, 65],
    x: 3883,
    y: 6818,
    spinner: true,
  },
  {
    name: "Swimmer Mina",
    numPokemon: 3,
    pokemonLevels: [57, 59, 62],
    x: 3946,
    y: 6673,
  },
  {
    name: "Picnicker Cheyenne",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 4005,
    y: 6803,
    spinner: true,
  },
  {
    name: "Bird Keeper Ernie",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 4155,
    y: 6844,
  },
  {
    name: "Swimmer Leona",
    numPokemon: 1,
    pokemonLevels: [66],
    x: 4429,
    y: 6843,
  },
  {
    name: "Picnicker Adrian",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 4715,
    y: 6825,
  },

  // Seaform Islands
  {
    name: "Skier Cady",
    numPokemon: 1,
    pokemonLevels: [80],
    x: 3966,
    y: 5505,
  },
  {
    name: "Boarder Shaun",
    numPokemon: 2,
    pokemonLevels: [83, 75],
    x: 4064,
    y: 5519,
    walker: true,
  },
  {
    name: "Boarder Bryce",
    numPokemon: 2,
    pokemonLevels: [83, 75],
    x: 4222,
    y: 5591,
  },

  // Route 20  (East of Seafoam)
  {
    name: "Camper Pedro",
    numPokemon: 1,
    pokemonLevels: [68],
    x: 4558,
    y: 6723,
  },
  {
    name: "Swimmer Luis",
    numPokemon: 2,
    pokemonLevels: [69, 63],
    x: 4332,
    y: 6509,
    spinner: true,
  },
  {
    name: "Swimmer Elmo",
    numPokemon: 2,
    pokemonLevels: [69, 63],
    x: 4928,
    y: 6622,
  },
  {
    name: "Swimmer Lori",
    numPokemon: 3,
    pokemonLevels: [63, 63, 63],
    x: 5122,
    y: 6762,
    walker: true,
  },
  {
    name: "Swimmer Nicole",
    numPokemon: 3,
    pokemonLevels: [59, 59, 63],
    x: 5435,
    y: 6659,
  },

  // Route 19
  {
    name: "Swimmer Tucker",
    numPokemon: 2,
    pokemonLevels: [60, 66],
    x: 5858,
    y: 6788,
  },
  {
    name: "Swimmer Debbie",
    numPokemon: 1,
    pokemonLevels: [69],
    x: 5879,
    y: 6787,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Swimmer Harold",
    numPokemon: 2,
    pokemonLevels: [63, 60],
    x: 5752,
    y: 6572,
    walker: true,
  },
  {
    name: "Swimmer Jerome",
    numPokemon: 4,
    pokemonLevels: [54, 57, 60, 57],
    x: 5820,
    y: 6385,
    spinner: true,
  },

  // Fuschia Gym
  {
    name: "Picnicker Cindy",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 5587,
    y: 5855,
  },
  {
    name: "Camper Barry",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 5444,
    y: 5917,
  },
  {
    name: "Lass Linda",
    numPokemon: 3,
    pokemonLevels: [62, 68, 65],
    x: 5443,
    y: 6007,
  },
  {
    name: "Lass Alice",
    numPokemon: 3,
    pokemonLevels: [62, 68, 62],
    x: 5540,
    y: 5932,
  },
  {
    name: "Janine",
    numPokemon: 6,
    pokemonLevels: [71, 71, 75, 66, 66, 71],
    x: 5507,
    y: 5980,
  },

  // Pewter Gym
  {
    name: "Camper Jerry",
    numPokemon: 1,
    pokemonLevels: [75],
    x: 2859,
    y: 1187,
  },
  {
    name: "Hiker Edwin",
    numPokemon: 1,
    pokemonLevels: [75],
    x: 2892,
    y: 1110,
  },
  {
    name: "Brock",
    numPokemon: 6,
    pokemonLevels: [77, 77, 81, 77, 80, 78],
    x: 2877,
    y: 967,
  },

  // Vermilion Gym
  {
    name: "Juggler Horton",
    numPokemon: 3,
    pokemonLevels: [65, 65, 65],
    x: 7165,
    y: 3989,
  },
  {
    name: "Guitarist Vincent",
    numPokemon: 3,
    pokemonLevels: [68, 65, 63],
    x: 7196,
    y: 3951,
  },
  {
    name: "Gentleman Gregory",
    numPokemon: 3,
    pokemonLevels: [69, 65, 63],
    x: 7277,
    y: 3964,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Lt. Surge",
    numPokemon: 6,
    pokemonLevels: [77, 71, 71, 80, 71, 71],
    x: 7212,
    y: 3840,
  },

  // Cerulean Gym
  {
    name: "Sailor Parker",
    numPokemon: 2,
    pokemonLevels: [65, 65],
    x: 8465,
    y: 1014,
    spinner: true,
  },
  {
    name: "Sailor Eddie",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 8479,
    y: 893,
  },
  {
    name: "Swimmer Diana",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 8378,
    y: 1003,
    walker: true,
  },
  {
    name: "Swimmer Joy",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 8304,
    y: 966,
    walker: true,
  },
  {
    name: "Swimmer Briana",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 8394,
    y: 930,
    walker: true,
  },
  {
    name: "Misty",
    numPokemon: 6,
    pokemonLevels: [74, 74, 74, 81, 74, 78],
    x: 8335,
    y: 764,
  },

  // Celadon Gym
  {
    name: "Twins Jo & Zoe",
    numPokemon: 2,
    pokemonLevels: [71, 71],
    x: 5559,
    y: 3566,
  },
  {
    name: "Lass Michelle",
    numPokemon: 3,
    pokemonLevels: [66, 68, 69],
    x: 5730,
    y: 3614,
  },
  {
    name: "Picnicker Tanya",
    numPokemon: 1,
    pokemonLevels: [74],
    x: 5680,
    y: 3404,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Beauty Julia",
    numPokemon: 3,
    pokemonLevels: [66, 71, 66],
    x: 5632,
    y: 3404,
  },
  {
    name: "Erika",
    numPokemon: 6,
    pokemonLevels: [77, 77, 84, 78, 77, 84],
    x: 5634,
    y: 3219,
  },

  // Saffron Gym
  {
    name: "Medium Rebecca",
    numPokemon: 2,
    pokemonLevels: [68, 68],
    x: 8212,
    y: 2298,
    spinner: true,
  },
  {
    name: "Psychic Jared",
    numPokemon: 3,
    pokemonLevels: [63, 63, 68],
    x: 8212,
    y: 2077,
    spinner: true,
  },
  {
    name: "Medium Darcy",
    numPokemon: 2,
    pokemonLevels: [66, 69],
    x: 7890,
    y: 2077,
    spinner: true,
  },
  {
    name: "Psychic Franklin",
    numPokemon: 2,
    pokemonLevels: [66, 71],
    x: 7890,
    y: 2298,
    spinner: true,
  },
  {
    name: "Sabrina",
    numPokemon: 6,
    pokemonLevels: [80, 83, 80, 80, 80, 80],
    x: 8051,
    y: 2150,
  },

  // Cinnabar Gym
  {
    name: "Scientist Lowell",
    numPokemon: 1,
    pokemonLevels: [75],
    x: 4742,
    y: 6305,
  },
  {
    name: "Scientist Daniel",
    numPokemon: 1,
    pokemonLevels: [75],
    x: 4631,
    y: 6306,
  },
  {
    name: "Super Nerd Cary",
    numPokemon: 1,
    pokemonLevels: [80],
    x: 4823,
    y: 6269,
  },
  {
    name: "Scientist Linden",
    numPokemon: 1,
    pokemonLevels: [75],
    x: 4773,
    y: 6232,
  },
  {
    name: "Super Nerd Waldo",
    numPokemon: 1,
    pokemonLevels: [80],
    x: 4710,
    y: 6194,
  },
  {
    name: "Super Nerd Merle",
    numPokemon: 1,
    pokemonLevels: [80],
    x: 4645,
    y: 6244,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Blaine",
    numPokemon: 6,
    pokemonLevels: [81, 81, 81, 81, 81, 89],
    x: 4709,
    y: 6243,
  },

  // Viridian Gym
  {
    name: "Ace Trainer Arabella",
    numPokemon: 2,
    pokemonLevels: [80, 78],
    x: 3653,
    y: 3440,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Ace Trainer Salma",
    numPokemon: 2,
    pokemonLevels: [75, 80],
    x: 3606,
    y: 3429,
  },
  {
    name: "Ace Trainer Bonita",
    numPokemon: 2,
    pokemonLevels: [75, 78],
    x: 3604,
    y: 3260,
  },
  {
    name: "Double Team Elan & Ida",
    numPokemon: 2,
    pokemonLevels: [78, 75],
    x: 3643,
    y: 3114,
  },
  {
    name: "Blue",
    numPokemon: 6,
    pokemonLevels: [83, 87, 84, 87, 90, 78],
    x: 3653,
    y: 3023,
  },

  // Red
  {
    name: "Red",
    numPokemon: 6,
    pokemonLevels: [100, 100, 100, 100, 100, 100],
    x: 786,
    y: 1029,
  },
];
